import { render, staticRenderFns } from "./RecordatorioModal.vue?vue&type=template&id=084b9647"
import script from "./RecordatorioModal.vue?vue&type=script&lang=js"
export * from "./RecordatorioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports